import React from 'react'
import Login from './Login'

function CoreLoginPage() {
  return (
    <div>
        <Login></Login>
    </div>
  )
}

export default CoreLoginPage